import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FC, createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatTimestamp } from "src/shared/helpers/dateTime-to-date";
import { roleIdToRoleName } from "src/shared/helpers/roleId-to-roleName";
import * as yup from "yup";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../shared/form-builder/form-builder.component";
import {
  approveUser,
  getPendingApprovalById,
  rejectUser,
} from "../../../../../store/slices/pending-approval.slice";
interface PendingApprovalTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  onRefetchData: () => void;
  isLoading: boolean;
}

const PendingApprovalTableComponent: FC<PendingApprovalTableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  onRefetchData,
  isLoading,
}) => {
  const formRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isApproveOpen, setIsApproveOpen] = useState<boolean>(false);
  const [rejectConfirmation, setRejectConfirmation] = useState(false);
  const [initialValues, setInitialValues] = useState<any>({
    userId: "",
    email: "",
    profileName: "",
    role: "",
    requestedAction: "",
    requestedBy: "",
  });

  const dispatch = useDispatch();

  const pendingApprovalDetails = useSelector((state: any) => {
    return state.pendingApproval.pendingApprovalDetails;
  });

  const isPendingApprovalLoading = useSelector((state: any) => {
    return state.pendingApproval.isPendingApprovalLoading;
  });

  const handleCloseModal = () => {
    setInitialValues({
      userId: "",
      email: "",
      profileName: "",
      role: "",
      requestedAction: "",
      requestedBy: "",
    });
    setIsModalOpen(false);
    setIsApproveOpen(false);
    setFormUpdate(0);
    setRejectConfirmation(false);
  };

  const approveClickAction = (id: number) => {
    setSelectedId(id);
    setIsApproveOpen(true);
    setIsModalOpen(true);
    dispatch(getPendingApprovalById({ id }));
  };

  // useEffect(() => {
  //   if (!isPendingApprovalLoading) return;
  //   setIsApproveOpen(true);
  //   setIsModalOpen(true);
  // }, [isPendingApprovalLoading]);

  const onRejectApproval = () => {
    // setIsApproveOpen(true);
    // setIsModalOpen(true);
    // setSelectedId(id);
    dispatch(rejectUser({ userId: selectedId })).then(() => {
      handleCloseModal();
      onRefetchData();
    });
  };

  const rejectClickAction: any = [
    {
      label: "Yes",
      event: onRejectApproval,
      variant: "primary",
    },
    // {
    //   label: "Reject",
    //   event: onReject,
    //   variant: "danger",
    // },
  ];
  const [formUpdate, setFormUpdate] = useState(0);

  useEffect(() => {
    if (!pendingApprovalDetails || !Object.keys(pendingApprovalDetails).length)
      return;

    // console.log(pendingApprovalDetails?.requestedAction);

    let convertedTimeAndDate = "";

    if (pendingApprovalDetails?.requestedAction) {
      convertedTimeAndDate = formatTimestamp(
        pendingApprovalDetails?.requestedAction ?? ""
      );
    }

    const roleName = roleIdToRoleName(pendingApprovalDetails?.roleId);

    setInitialValues({
      userId: pendingApprovalDetails?.userId || "",
      profileName: pendingApprovalDetails?.profileName || "",
      email: pendingApprovalDetails?.email || "",
      role: roleName || "",
      requestedAction: pendingApprovalDetails?.requestedAction || "",
      requestedBy: pendingApprovalDetails?.requestedBy || "",
    });

    setFormUpdate(formUpdate + 1);
    // setIsModalOpen(true);
  }, [pendingApprovalDetails]);

  const onApprove = () => {
    dispatch(
      approveUser({ userId: selectedId })
    ).then(() => {
      handleCloseModal();
      onRefetchData();
    });
  };

  // const onReject = () => {
  //   // console.log(selectedId);
  //   dispatch(rejectUser({ userId: selectedId })).then(() => {
  //     handleCloseModal();
  //     onRefetchData();
  //   });

  //   return;
  //   // handleCloseModal();
  // };

  const modalActionConfig: any = [
    {
      label: "Approve",
      event: onApprove,
      variant: "primary",
    },
    // {
    //   label: "Reject",
    //   event: onReject,
    //   variant: "danger",
    // },
  ];

  // const rejectActionConfig: any = [
  //   {
  //     label: "Yes",
  //     event: action,
  //     variant: "primary",
  //   },
  // ];

  const rejectActionConfig = (id: number) => {
    setSelectedId(id);
    setRejectConfirmation(true);
  };

  const actionConfig: any = [
    {
      label: "Approve",
      actionProperty: "id",
      event: approveClickAction,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "Pending Approval",
      actionName: "Approve-Pending Approval",
      icon: faCheck,
    },
    {
      label: "Reject",
      actionProperty: "id",
      event: rejectActionConfig,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "Pending Approval",
      actionName: "Approve-Pending Approval",
      icon: faCheck,
    },
  ];

  const emptyConfig = {
    title: "No Pending Approval Found",
    description: "",
  };

  const formConfig: FormConfig = {
    controls: [
      {
        name: "userId",
        label: "User Id",
        type: "text",
        display: false,
        required: true,
        readOnly: true,
        disabled: true,
      },
      {
        name: "email",
        label: "Email",
        placeholder: "exmaple@domain.com",
        type: "email",
        display: false,
        required: true,
        readOnly: true,
        disabled: true,
      },
      {
        name: "profileName",
        label: "User Name",
        type: "text",
        required: true,
        readOnly: true,
        disabled: true,
      },
      {
        name: "role",
        label: "Role",
        placeholder: "TC Operator",
        type: "text",
        required: true,
        readOnly: true,
        disabled: true,
      },
      // {
      //   name: "secretCode",
      //   label: "Secret Code",
      //   type: "text",
      //   required: true,
      //   readOnly: true,
      //   disabled: true,
      // },
      {
        name: "requestedAction",
        label: "Requested Action",
        placeholder: "Requested Action",
        type: "text",
        required: true,
        readOnly: true,
        disabled: true,
      },
      {
        name: "requestedBy",
        label: "Requested By",
        placeholder: "Requested By",
        type: "text",
        required: false,
        readOnly: true,
        disabled: true,
      },
    ],
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    role: yup
      .string()
      .min(5, "User Id must be at least 5 characters")
      .required("Role is required"),
    requestedAction: yup.string().required("Requested Action is required"),
  });

  return (
    <div>
      <div className="my-3">
        <TableComponent
          tableHeaders={columns}
          emptyConfig={emptyConfig}
          data={data}
          totalNumberOfRecords={totalNumberOfRecords}
          pageSize={pageSize}
          current={current}
          onChangePage={onChangePage}
          actionConfig={actionConfig}
          onChangeSort={onChangeSort}
          isLoadingData={isLoading}
        />
      </div>

      {/* modals */}
      {isModalOpen && (
        <ModalComponent
          showModal={isApproveOpen}
          handleClose={handleCloseModal}
          headerTitle={"Approve Pending Approval"}
          actionConfig={modalActionConfig}
        >
          <FormBuilderComponent
            renderCount={formUpdate}
            formRef={formRef}
            initialValues={initialValues}
            validation={validationSchema}
            formConfig={formConfig}
          />
        </ModalComponent>
      )}

      {rejectConfirmation && (
        <ModalComponent
          isConformationModal={rejectConfirmation}
          showModal={true}
          handleClose={handleCloseModal}
          headerTitle="Confirm Reject Approval"
          actionConfig={rejectClickAction}
        >
          <h5>
            {" "}
            Are you sure to <strong>Reject Approval</strong>?{" "}
          </h5>
        </ModalComponent>
      )}
    </div>
  );
};

export default PendingApprovalTableComponent;
